import React from 'react'

import { Button, Divider, Row, Col } from '_zari/core'

import ResumenVentas from 'partials/resumenVenta'

const DetalleVentasSection = ({ idFacturacion, anio, mostrarVentasSection }) => {
  return (
    <>
      <Row>
        <Col md={12}>
          <Button tiny outline color='secondary' onClick={mostrarVentasSection}>
            {'< Retroceder'}
          </Button>
        </Col>
      </Row>
      <Divider />
      <ResumenVentas id={idFacturacion} tipo='modal' anio={anio} />
    </>
  )
}

export default React.memo(DetalleVentasSection)
